"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var HttpClient = /** @class */ (function () {
    function HttpClient(baseURL) {
        this.handleError = function (error) { return Promise.reject(error); }; //Promise<never> | void 
        this.instance = axios_1.default.create({ baseURL: baseURL });
        this.instance.interceptors.response.use(function (_a) {
            var data = _a.data;
            return data;
        }, this.handleError);
    }
    return HttpClient;
}());
exports.default = HttpClient;
//cref:https://levelup.gitconnected.com/enhance-your-http-request-with-axios-and-typescript-f52a6c6c2c8e
//# sourceMappingURL=HttpClient.js.map